import axiosInstance from '../RestClient';

class StatementService {
	/** "Estado de cuenta" PDF for a debt or credit; `dueIds` empty = all dues. */
	async getPdf(kind, id, dueIds = []) {
		const uri = `/statements/${kind}/${id}/pdf`;
		return axiosInstance.get(uri, { params: { dues: dueIds.join(',') }, responseType: 'blob' });
	}
}

export default new StatementService();
